<template>
  <div class="ui-padding-main">
    <div class="ui-main-container" v-loading="loading">
      <detail-box :detail="tenderDetail" content-box-style="min-height: 6em;" btn-group-style="padding-right: 0px;">
        <div class="flex attachment-group" v-show="this.issupplier=='true'">
          <el-button
            type="primary"
            plain
            class="btn-attachment"
            size="mini"
            @click="runRpt"
            :loading="running"
            :disabled="running"
          >
            {{ running ? buttonLabel.loading : buttonLabel.print }}
          </el-button>
          <el-button
            type="primary"
            plain
            class="btn-attachment"
            size="mini"
            @click="changeUploadVisible"
            :loading="uploadLoading"
            :disabled="this.tenderDetail.status!='WTQUOTE'"
          >
            {{
              uploadLoading ? buttonLabel.adding : buttonLabel.addattachment
            }}
          </el-button>
          <el-button
            type="primary"
            plain
            class="btn-attachment"
            size="mini"
            style="width:200px"
            @click="showSupplierAttachments"
            v-show="!this.supplierattachments.length"
          >
            {{ buttonLabel.getsupdoc }}
          </el-button>
          <el-button
            type="primary"
            class="btn-attachment"
            size="mini"
            style="width:200px"
            @click="showSupplierAttachments"
             v-show="this.supplierattachments.length"
          >
            {{ buttonLabel.getsupdoc }}
          </el-button>
          <el-button
            type="primary"
            plain
            class="btn-attachment"
            size="mini"
            style="width:150px"
            @click="showAttachments"
            v-show="!this.attachments.length"
          >
            {{ buttonLabel.viewattachments }}
          </el-button>
          <el-button
            type="primary"
            class="btn-attachment"
            size="mini"
            style="width:180px"
            @click="showAttachments"
            v-show="this.attachments.length"
          >
            {{ buttonLabel.viewattachments }}
          </el-button>
        </div>
      </detail-box><br>
       <el-row type="flex" justify="space-between">
        <el-col class="text-right">
          <el-button type="primary" @click="acceptTender" :disabled="showButton_3" v-if="this.tenderDetail.status=='DRAFT' && this.issupplier=='true'">
            {{ buttonLabel.accept }}
          </el-button>
          <el-button type="primary" @click="rejectTender" :disabled="showButton_4" v-if="this.tenderDetail.status=='DRAFT' && this.issupplier=='true'">
            {{ buttonLabel.reject }}
          </el-button>
        </el-col>
      </el-row>
      <el-divider><div style="color:red">Items with * are required, and those without * are optional</div></el-divider>
      <el-table
        class="ui-table"
        :header-cell-class-name="tableHeaderCellClassName"
        style="margin-bottom: 20px;width: 100%"
        border
        :data="tableData"  
      >
        <el-table-column
          prop="seqno"
          :label="tableLabel.seqNo"
          style="width: 6%"
          align="center"
        ></el-table-column>
        <el-table-column :label="tableLabel.description"  style="width: 24%">
          <template slot-scope="scope">
            <div class="flex flex-align-items-center">
              <div class="flex1 ">
                <div class="line-word-break" >
                  <div v-if="scope.row.underline=='1'" style="text-decoration:underline"> 
                    <div v-if="scope.row.bold=='1'" style="font-weight:700">{{ scope.row.description }} <br> {{ scope.row.longdesc }}</div>
                    <div v-if="scope.row.bold=='0'" > {{ scope.row.description }} <br> {{ scope.row.longdesc }}</div>
                  </div>
                  <div v-if="scope.row.underline=='0'"> 
                    <div v-if="scope.row.bold=='1'" style="font-weight:700"> {{ scope.row.description }} <br> {{ scope.row.longdesc }}</div>
                    <div v-if="scope.row.bold=='0'" > {{ scope.row.description }} <br> {{ scope.row.longdesc }}</div>
                  </div>
                </div>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column :label="tableLabel.remark"  style="width: 24%">
          <template slot-scope="scope">
            <div class="flex flex-align-items-center">
              <div class="flex1" >
                <div class="line-word-break">
                  <div v-if="scope.row.underline=='1'" style="text-decoration:underline"> 
                    <div v-if="scope.row.bold=='1'" style="font-weight:700"> {{ scope.row.remark }}</div>
                    <div v-if="scope.row.bold=='0'" > {{ scope.row.remark }}</div>
                  </div>
                  <div v-if="scope.row.underline=='0'"> 
                    <div v-if="scope.row.bold=='1'" style="font-weight:700"> {{ scope.row.remark }}</div>
                    <div v-if="scope.row.bold=='0'" > {{ scope.row.remark }}</div>
                  </div>
                  
                </div>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="quantity" :label="tableLabel.quantity" style="width: 7%" :formatter="numFormat">
          <template slot-scope="scope">
            <div class="flex flex-align-items-center">
                <el-input-number
                  v-input-filter:num
                  v-model="
                    list[
                      scope.$index +
                        (paginationConfig.page - 1) * paginationConfig.pageSize
                    ].quantity
                  "
                  :controls="false"
                  :precision="2"
                  style="width: 95%"
                  :disabled="list[
                      scope.$index +
                        (paginationConfig.page - 1) * paginationConfig.pageSize
                    ].qtyrequired=='0' || showInput || tenderDetail.tendercollectvia=='HardCopy'"
                  v-if="list[
                      scope.$index +
                        (paginationConfig.page - 1) * paginationConfig.pageSize
                    ].header=='0'"
                ></el-input-number>
                 <span class="red" v-if="list[
                      scope.$index +
                        (paginationConfig.page - 1) * paginationConfig.pageSize
                    ].qtyrequired == '1' && list[
                      scope.$index +
                        (paginationConfig.page - 1) * paginationConfig.pageSize
                    ].header=='0'">*</span>
                <span class="red" slot="error"></span>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="unit"
          :label="tableLabel.unit"
          style="width: 6%"
          align="center"
        ></el-table-column>
        <el-table-column prop="unitprice" :label="tableLabel.unitPrice" style="width: 10%" >
          <template slot-scope="scope">
            <div class="flex flex-align-items-center" >
              <div class="flex1" >
                <el-input
                  :id="'unitprice' + scope.$index"
                  v-model="scope.row.unitprice"
                  :disabled="showInput || tenderDetail.tendercollectvia=='HardCopy'"
                  :controls="false"
                  :precision="2"
                  style="width: 95%"
                  
                  @change="unitpriceformaters(scope.row.unitprice,scope.$index)"
                  @focus="unitpriceunformats(scope.row.unitprice,scope.$index)"
                  v-if="scope.row.header=='0' && scope.row.required=='1'"
                ></el-input>
                 <span class="red" v-if="scope.row.required == '1' && scope.row.header=='0'">*</span>
                <span class="red" slot="error"></span>
              </div>
            </div>
          </template>
        </el-table-column>
         <el-table-column prop="totallineamount" :label="tableLabel.lineTotal" style="width: 10%" >
          <template slot-scope="scope">
            <div class="flex flex-align-items-center">
              <div class="flex1" > 
                <el-input
                  :id="'amount' + scope.$index"
                  v-model="scope.row.totallineamount"
                  :disabled="showInput || tenderDetail.tendercollectvia=='HardCopy'"
                  :controls="false"
                  :precision="2"
                  style="width: 95%"
                  
                  @change="totalamountformaters(scope.row.totallineamount,scope.$index)"
                  @focus="totalamountunformats(scope.row.totallineamount,scope.$index)"
                  v-if="scope.row.header=='0' && scope.row.totalamountreq=='1'"
                ></el-input>
                 <span class="red" v-if="scope.row.totalamountreq == '1' && scope.row.header=='0'">*</span>
                <span class="red" slot="error"></span>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="linenotes" :label="tableLabel.notes" style="width: 17%">
          <template slot-scope="scope">
            <div class="flex flex-align-items-center">
              <div class="flex1" >
                <el-input
                  v-model="scope.row.linenotes"
                  :disabled="showInput || tenderDetail.tendercollectvia=='HardCopy'"
                  :controls="false"
                  v-if="list[
                      scope.$index +
                        (paginationConfig.page - 1) * paginationConfig.pageSize
                    ].header=='0' && list[
                      scope.$index +
                        (paginationConfig.page - 1) * paginationConfig.pageSize
                    ].neednotes=='1'"
                ></el-input> 
                <span class="red" slot="error"></span>
              </div>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        background
        :hide-on-single-page="true"
        layout="prev, pager, next"
        :page-size="paginationConfig.pageSize"
        :total="paginationConfig.total"
        @current-change="handleCurrentChange"
        style="margin-bottom:20px;"
      ></el-pagination>
      <el-row type="flex" justify="space-between">
        <el-col>
          <el-button plain @click="goBack">
            {{ $t("common_pageText.RETURN") }}
          </el-button>
        </el-col>
        <el-col class="text-right">
          <el-button type="primary" :disabled="tenderDetail.tendercollectvia=='HardCopy'" @click="rejectTender"  v-if="this.tenderDetail.status=='WTQUOTE' && this.issupplier=='true'">
            {{ buttonLabel.reject }}
          </el-button>
          <el-button type="primary" :disabled="tenderDetail.tendercollectvia=='HardCopy'" @click="savePrice" 
          v-show="(showButton && this.tenderDetail.status=='WTQUOTE')">
            {{ buttonLabel.save }}
          </el-button>
          <el-button type="primary" @click="savePriceInputed" 
          v-show="this.issupplier=='false' && this.tenderDetail.inputed=='0' && this.tenderDetail.bidmethod=='HardCopy'">
            {{ $t("common_pageText.SUBMIT") }}
          </el-button>
          <el-button type="primary" :disabled="tenderDetail.tendercollectvia=='HardCopy'"  @click="confirmSubmit" v-show="showButton && this.tenderDetail.status=='WTQUOTE' && this.issupplier=='true'">
            {{ $t("common_pageText.SUBMIT") }}
          </el-button>
        </el-col>
      </el-row>
    </div>
    <el-dialog title :visible.sync="visible">
      <detail-box
        :detail="seqDetail"
        content-box-style="min-height: 6em; max-height: 50vh"
      ></detail-box>
    </el-dialog>
    <el-dialog :title="uploadText.upload" width="30%" :visible.sync="uploadVisible" :close-on-click-modal="false">
      <span>Description :<el-input v-model="filedesc" ></el-input></span>
      <el-divider></el-divider>
      <el-upload
      style="margin: auto 10px;"
      action=""
      name="file"
      ref="upload"
      :multiple="false"
      :auto-upload="false"
      :show-file-list="true"
      :file-list="fileList"
      :on-change="upload"
      :on-remove="handleRemove"
      >
      <el-button slot="trigger" style="margin-left: -10px;" size="small" type="primary" >Select Files</el-button>
      <el-button style="margin-left: 10px;" size="small" type="success" @click="saveUpload" :disabled="savebutton">Save</el-button>
      </el-upload>
    </el-dialog>
    <el-dialog
      width="30%"
      :show-close="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :visible.sync="promptVisible"
      center
    >
      <span v-html="dialogHtml" ></span>
      <span slot="footer" class="dialog-footer">
        <el-button plain @click="promptVisible = false">
          {{ buttonLabel.dontagree }}
        </el-button>
        <el-button type="primary" @click="saveSubmit" :disabled="agreeButtonDisabled">
          {{ buttonLabel.agree }}
        </el-button>
      </span>
    </el-dialog>
    <el-dialog
      width="29%"
      :show-close="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :visible.sync="rejectVisible"
      center
    >
      <div style="height:80px;">
        <span v-html="noDeclineTips" v-if="tenderDetail.tendercollectvia=='HardCopy'" ></span>
        <span v-if="tenderDetail.tendercollectvia!='HardCopy'">{{rejectTips}}</span>
      </div>
      <el-divider v-if="tenderDetail.tendercollectvia!='HardCopy'"></el-divider>
      <span><el-input placeholder="Please enter the reason for rejection"
        v-model="rejectreason" v-if="tenderDetail.tendercollectvia!='HardCopy'"></el-input></span>
      <span slot="footer" class="dialog-footer">
        <el-button plain @click="rejectVisible = false" v-if="tenderDetail.tendercollectvia!='HardCopy'">
          {{ buttonLabel.cancel }}
        </el-button>
        <el-button type="primary" @click="tenderDetail.tendercollectvia=='HardCopy'? HCreject() : NHCreject()" 
        :disabled="tenderDetail.tendercollectvia=='HardCopy' ? false : ! rejectreason">
          {{ buttonLabel.confirm }}
        </el-button>
      </span>
    </el-dialog>
    <table-dialog
      :title="tableLabel.attachmentsattachments"
      :list="attachments"
      :show.sync="attachmentVisible"
      :tableHeaderCellClassName="tableHeaderCellClassName"
      :tableContentCellClassName="tableContentCellClassName"
    >
      <el-table-column
        prop="filetype"
        :label="tableLabel.attachmentType"
        width="150"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="document"
        align="center"
        :label="tableLabel.attachmentName"
      ></el-table-column>
      <el-table-column
        prop="description"
        align="center"
        :label="tableLabel.attachmenDesc"
      ></el-table-column>
      <el-table-column width="150">
        <template slot-scope="scope">
          <el-button
            type="primary"
            size="small"
            @click="download(scope.row.serverurl)"
          >
            {{ buttonLabel.download }}
          </el-button>
        </template>
      </el-table-column>
    </table-dialog>
    <el-dialog
          width="31%"
          title="Tips"
          :show-close="false"
          :close-on-click-modal="false"
          :close-on-press-escape="false"
          :visible.sync="saveTipsShow"
          center
        >
          <span v-html="saveTips"></span><br><br>
          <el-checkbox v-model="checked" style="float:fight">{{noReminderTips}}</el-checkbox>
          <span slot="footer" class="dialog-footer"> 
            <el-button plain @click="saveTipsShow = false">
              {{ buttonLabel.cancel }}
            </el-button>
            <el-button type="primary" @click="saveTipsConfirm" :disabled="saveButtonDisabled">
              {{ buttonLabel.confirm }}
            </el-button>
          </span>
        </el-dialog>
         <el-dialog
          width="20%"
          :show-close="false"
          :close-on-click-modal="false"
          :close-on-press-escape="false"
          :visible.sync="noDeclineTipsShow"
          center
        >
          <span v-html="noDeclineTips"></span>
          <span slot="footer" class="dialog-footer"> 
            <el-button plain @click="noDeclineTipsShow = false">
              {{ buttonLabel.confirm }}
            </el-button>
          </span>
        </el-dialog>
    <table-dialog
      :title="tableLabel.supplierattachments"
      :list="supplierattachments"
      :show.sync="supplierattachmentVisible"
      :tableHeaderCellClassName="tableHeaderCellClassName"
      :tableContentCellClassName="tableContentCellClassName"
    >
      <el-table-column
        prop="filetype"
        :label="tableLabel.attachmentType"
        width="150"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="document"
        align="center"
        :label="tableLabel.attachmentName"
      ></el-table-column>
      <el-table-column
        prop="description"
        align="center"
        :label="tableLabel.attachmenDesc"
      ></el-table-column>
      <el-table-column width="150">
        <template slot-scope="scope">
          <el-button
            type="primary"
            size="small"
            @click="download(scope.row.serverurl)"
          >
            {{ buttonLabel.download }}
          </el-button>
        </template>
      </el-table-column>
      <el-table-column width="150">
        <template slot-scope="scope">
          <el-button
            type="primary"
            size="small"
            v-show="tenderDetail.status=='WTQUOTE'"
            @click="deleteUploadFile(scope.row.docinfoid)"
          >
            {{ buttonLabel.deleteUploadFile }}
          </el-button>
        </template>
      </el-table-column>
    </table-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import merge from 'webpack-merge';
import detailbox from "../../components/tender/DetailBox";
import tableDialog from "../../components/dialog/tableDialog";
import { postRequest,token } from "../../utils/api";
import { cusError } from "../../utils/utils.js";
import { getRptIP } from '../../utils/server';
import inputFilter from '../../utils/filter.js';
export default {
  components: {
    "detail-box": detailbox,
    "table-dialog": tableDialog
  },
  mounted() {
    this.init();
  },
  data() {
    return {
      testprice: "",
      //status: this.list[index].required,
      price: null,
      filedesc: "",
      savebutton: false,
      agreeButtonDisabled: false,
      saveButtonDisabled: false,
      list: [],
      tableData: [],
      showButton:true,
      showButton_1:false,
      showButton_2:false,
      showButton_3:false,
      showButton_4:false,
      showInput:false,
      tenderEnddate:"",
      tenderIsOverdue:false,
      tenderDetail: {
        udztbid: "",
        unit: "",
        linenotes: "",
        status: "",
        bidmethod: "",
        inputed: "",
        reminder: "",
        tendercollectvia: "",
        title: {
          label: this.$t("tenderInfo_pageText.TENDERNO"),
          value: ""
        },
        suppliername: {
          label: "Supplier Name",
          value: ""
        },
        content: {
          label: this.$t("tenderInfo_pageText.DESCRIPTION"),
          value: ""
        },
        tendercollectvias: {
          label: "Tender Collect Via",
          value: ""
        },
        closingdate: {
          label: "Closing Date",
          value: ""
        },
        contact1: {
          label: "Tender Contacts 1",
          value: ""
        },
        contact2: {
          label: "Tender Contacts 2",
          value: ""
        },
        remark: {
          label: this.$t("tenderInfo_pageText.REMARKTOSUPPLIER"),
          value: ""
        },
        supplier:{
          label: this.$t("tenderInfo_pageText.SUPPLIERTOJLL"),
          value: ""
        }
      },
      tableLabel: {
        seqNo: this.$t("tenderInfo_pageText.SEQNO"),
        description: this.$t("tenderInfo_pageText.DESCRIPTION"),
        remark: this.$t("tenderInfo_pageText.REMARK"),
        quantity: this.$t("tenderInfo_pageText.QUANTITY"),
        unitPrice: this.$t("tenderInfo_pageText.UNITPRICE"),
        lineTotal: this.$t("tenderInfo_pageText.LINETOTAL"),
        attachments: this.$t("tenderInfo_pageText.ATTACHMENTS"),
        supplierattachments: "Supplier Attachments",
        attachmentId: this.$t("tenderInfo_pageText.ATTACHMENTID"),
        attachmentType: this.$t("tenderInfo_pageText.ATTACHMENTTYPE"),
        attachmentName: this.$t("tenderInfo_pageText.ATTACHMENTNAME"),
        attachmenDesc: "Attachment Description",
        notes: "Notes",
        unit: "Unit",
      },
      paginationConfig: {
        page: 1,
        pageSize: 10,
        total: 0
      },
      buttonLabel: {
        more: this.$t("common_pageText.MORE"),
        return: this.$t("common_pageText.RETURN"),
        submit: this.$t("common_pageText.SUBMIT"),
        confirm: this.$t("common_pageText.CONFIRM"),
        cancel: this.$t("common_pageText.CANCEL"),
        download: this.$t("common_pageText.DOWNLOAD"),
        upload: this.$t("common_pageText.UPLOAD"),
        uploadattachment: this.$t("tenderInfo_pageText.UPLOADATTACHMENT"),
        addattachment: this.$t("tenderInfo_pageText.ADDATTACHMENT"),
        adding: this.$t("tenderInfo_pageText.ADDING"),
        viewattachments: "Tender Attachments",
        print: this.$t("tenderInfo_pageText.PRINT"),
        loading: this.$t("tenderInfo_pageText.LOADING"),
        save: this.$t("common_pageText.SAVE"),
        accept: "Read",
        reject: "Decline",
        getsupdoc: "Vendor Submitted Documents",
        agree: "I Agree.",
        dontagree: "I Don't Agree.",
        deleteUploadFile: "Delete",
      },
      promptText: {
        prompt: this.$t("common_pageText.PROMPT"),
        confirmSubmit: this.$t("prompt_pageText.CONFIRMSUBMIT")
      },
      uploadText:{
        upload: "Upload File"
      },
      visible: false,
      seqDetail: {
        title: {
          label: this.$t("tenderInfo_pageText.SEQNO"),
          value: ""
        },
        content: {
          label: "",
          value: ""
        }
      },
      promptVisible: false,
      attachments: [],
      supplierattachments: [],
      attachmentVisible: false,
      supplierattachmentVisible: false,
      attachmentLoading: false,
      supplierattachmentLoading: false,
      loading: false,
      uploadLoading: false,
      fileList: [],
      running: false,
      urlStatus: "",
      suppliername: "",
      totalcount:"",
      issupplier:"",
      rfqnum:"",
      inputView: "0",
      inputView2: "0",
      uploadVisible: false,
      //saveSuccess: true,
      dialogHtml: "",
      uploadTips: "",
      saveTips: "",
      noReminderTips: "",
      noDeclineTips: "",
      noDeclineTipsShow: false,
      checked: false,
      savereminder: "0",
      saveTipsShow: false,
      tendercollectviaTipsShow: false,
      user: {
        loginid: "",
        logintype: "0",
        token: ""
      },
      checksession: true,
      timeOutTips: "",
      rejectreason: "",
      rejectReasonIsNull: true,
      rejectVisible: false,
      rejectTips: this.$t("tenderInfo_pageText.REJECT_TIPS")
    };
  },
  directives:{
    inputFilter
  },
  filters: {
    
  },
  computed: {
    ...mapGetters("user", ["hrid", "siteid", "language"]),
  },
  created() {
  },
  props: ["id","status","str"],
  methods: {
    changeLang(lang) {
      this.$i18n.locale = lang;
      // this.reload();
    },
    init() {
      // if(!parseInt(this.totalcount)) {
      //   this.totalcount = "20"
      // }
      //this.getTimeOutMessage();
      this.checkSession();
      if(this.checksession){
        this.issupplier = this.$cookies.get("issupplier");
        this.suppliername = this.$route.params.suppliername;
        this.totalcount = this.$route.params.totalcount;
        this.rfqnum = this.$route.params.rfqnum;
        //console.log(this.$route.params);
        this.urlStatus = this.$route.params.status;
        this.changeLang(this.language);
        this.getDialogHtml();
        this.getTenderInfo();
        //console.log('issupplier:'+this.issupplier);
        if(this.issupplier=='true'){
          this.getAttachments();
          this.getSupplierAttachments();
        }else{
          //console.log('xxxxxx');
        }
        this.getUploadTips();
        this.getSaveTips();
        this.getNoDeclineTips();
        this.getNoReminderTips();
      }
      

      
      
    },
    blurevent(){this.inputView = "0";console.log("inputView:"+this.inputView)},
    focusevent(){this.inputView = "1";console.log("inputView:"+this.inputView)},
    blureventPrice(){this.inputView2 = "0";console.log("inputView2:"+this.inputView2)},
    focuseventPrice(){this.inputView2 = "1";console.log("inputView2:"+this.inputView2)},
    formater(value) {
      if (!value) {
          return;
      }
      let val = value;
      val = val.toString().replace(/\$|\,/g, "");
      if (isNaN(val)) {
         return ;
      }
      // eslint-disable-next-line eqeqeq
      let sign = (val == (val = Math.abs(val)));
      val = Math.floor(val * 100 + 0.50000000001);
      let cents = val % 100;
      val = Math.floor(val / 100).toString();
      if (cents < 10) {
          cents = "0" + cents;
      }
      for (let i = 0; i < Math.floor((val.length - (1 + i)) / 3); i++) {
          val = val.substring(0, val.length - (4 * i + 3)) + "," + val.substring(val.length - (4 * i + 3));
      }
      return (((sign) ? "" : "-") + val + "." + cents);
    },
    totalamountformaters(value,index) {
      this.checkSession();
      if(this.checksession){
        if (!value) {
          return;
        }
        let val = value;
        val = val.toString().replace(/\$|\,/g, "");
        if (isNaN(val)) {
          return ;
        }
        // eslint-disable-next-line eqeqeq
        let sign = (val == (val = Math.abs(val)));
        val = Math.floor(val * 100 + 0.50000000001);
        let cents = val % 100;
        val = Math.floor(val / 100).toString();
        if (cents < 10) {
            cents = "0" + cents;
        }
        for (let i = 0; i < Math.floor((val.length - (1 + i)) / 3); i++) {
            val = val.substring(0, val.length - (4 * i + 3)) + "," + val.substring(val.length - (4 * i + 3));
        }
        let newval = (((sign) ? "" : "-") + val + "." + cents);
        this.tableData[index].totallineamount = newval;
        return newval;
      }
      
    },
    unitpriceformaters(value,index) {
      this.checkSession();
      if(this.checksession){
        if (!value) {
          return;
        }
        let val = value;
        val = val.toString().replace(/\$|\,/g, "");
        if (isNaN(val)) {
          return ;
        }
        // eslint-disable-next-line eqeqeq
        let sign = (val == (val = Math.abs(val)));
        val = Math.floor(val * 100 + 0.50000000001);
        let cents = val % 100;
        val = Math.floor(val / 100).toString();
        if (cents < 10) {
            cents = "0" + cents;
        }
        for (let i = 0; i < Math.floor((val.length - (1 + i)) / 3); i++) {
            val = val.substring(0, val.length - (4 * i + 3)) + "," + val.substring(val.length - (4 * i + 3));
        }
        let newval = (((sign) ? "" : "-") + val + "." + cents);
        this.tableData[index].unitprice = newval;
        return newval;
      }
      
    },
    unformat(value){
      //this.checkSession();
      if (!value) {
          return;
      }
      let val = value;
      let newval = val.replace(/,/g,'');
      //console.log(newval);
      return newval;
    },
    totalamountunformats(value,index){
      this.checkSession();
      if(this.checksession){
        if (!value) {
          return;
        }
        //console.log(index);
        let val = value;
        let newval = val.replace(/,/g,'');
        this.tableData[index].totallineamount = newval;
        //console.log(newval);
        return newval;
      }
      
    },
    unitpriceunformats(value,index){
      this.checkSession();
      if(this.checksession){
        if (!value) {
          return;
        }
        //console.log(index);
        let val = value;
        let newval = val.replace(/,/g,'');
        this.tableData[index].unitprice = newval;
        //console.log(newval);
        return newval;
      }
      
    },
    numFormat(cellValue,row,column){
      cellValue += '';
			if (!cellValue.includes('.')) cellValue += '.';
			return cellValue.replace(/(\d)(?=(\d{3})+\.)/g, function ($0, $1) {
				return $1 + ',';
			}).replace(/\.$/, '');
    },

    goBack() {
      this.checkSession();
      if(this.checksession){
        let oldStatus = this.$cookies.get("urlstatus");
        let oldStatus2 = this.$cookies.get("urlstatus2");
        let newStatus = this.urlStatus;
        if(oldStatus && oldStatus2){
          this.$router.go(-3);
          //console.log('1111');
          this.$store.commit("user/removeUrlstatus"); 
        }else if(oldStatus && !oldStatus2){
            if(oldStatus!=newStatus){
              this.$router.go(-2);
              //console.log('2222');
              this.$store.commit("user/removeUrlstatus");
            }else{
              this.$router.go(-1);
              //console.log('3333');
              this.$store.commit("user/removeUrlstatus");
          }
        }else if(!oldStatus && oldStatus2){
            if(oldStatus2!=newStatus){
              this.$router.go(-2);
              //console.log('4444');
              this.$store.commit("user/removeUrlstatus");
            }else{
              this.$router.go(-1);
              //console.log('5555');
              this.$store.commit("user/removeUrlstatus");
          }
        }else{
          this.$router.go(-1);
          //console.log('6666');
        }
      }
    },
    showInfo(index, type) {
      let seq = this.list[index];
      this.seqDetail.title.value = seq.seqno;
      this.seqDetail.content.label = this.$t(`tenderInfo_pageText.${type}`);
      this.seqDetail.content.value = seq[type.toLowerCase()];
      this.visible = true;
    },
    showAttachments() {
      this.checkSession();
      if(this.checksession){
        this.attachmentVisible = true;
        this.getAttachments();
      }
    },
    showSupplierAttachments() {
      this.checkSession();
      if(this.checksession){
        this.supplierattachmentVisible = true;
        this.getSupplierAttachments();
      }   
    },
    changeFileList(){
      let _this = this;
      let reffilelist = _this.$refs.upload.uploadFiles;
      if(reffilelist){

        for(let i=0;i<reffilelist.length;i++){
           reffilelist[i].description = this.filedesc;
        }
        _this.fileList = reffilelist;
       
      }
      // console.log(_this.fileList);
      //console.log(reffilelist);
    },
    //供应商搜索框搜索列表进入
    getTenderDetail_1() {
      return postRequest("getList", {
        reqname: "getudztb",
        hrid: this.hrid,
        udztbnum: this.id,
        page: "1",
        pagesize: this.totalcount,
        str: this.str,
        status: "in ('"+ this.status +"')"
      })
        .then(res => {
          const data = res.data;
          if (data.getudztb.length) {
            const tenderDetails = data.getudztb[0];
            this.tenderDetail.title.value = tenderDetails.rfqnum;
            this.tenderDetail.udztbid = tenderDetails.udztbid;
            this.tenderDetail.suppliername.value = tenderDetails.suppliername;
            this.tenderDetail.content.value = tenderDetails.tenderdesc;
            this.tenderDetail.unit=tenderDetails.unit;
            this.tenderDetail.remark.value = tenderDetails.remark;
            this.tenderDetail.supplier.value = tenderDetails.commentstojll;
            this.tenderDetail.notes = tenderDetails.linenotes;
            this.tenderDetail.status = tenderDetails.status;
            this.tenderDetail.closingdate.value = tenderDetails.enddate;
            this.tenderDetail.reminder = tenderDetails.reminder;
            this.tenderDetail.tendercollectvia = tenderDetails.tendercollectvia;
            this.tenderDetail.tendercollectvias.value = tenderDetails.tendercollectvia;
            this.tenderDetail.contact1.value = (tenderDetails.contact1 )
            +(tenderDetails.email1!="" ? " ," + tenderDetails.email1 : tenderDetails.email1)
            +(tenderDetails.phone1!="" ? " ," + tenderDetails.phone1 : tenderDetails.phone1);
            this.tenderDetail.contact2.value = (tenderDetails.contact2 )
            +(tenderDetails.email2!="" ? " ," + tenderDetails.email2 : tenderDetails.email2)
            +(tenderDetails.phone2!="" ? " ," + tenderDetails.phone2 : tenderDetails.phone2);
            // console.log("this.tenderDetail");
            // console.log(this.tenderDetail);
            if(new Date()>new Date(tenderDetails.enddate)){
              this.tenderIsOverdue = true;
            }else{
              this.tenderIsOverdue = false;
            }
            // if(tenderDetails.tendercollectvia=="HardCopy"){
            //   this.showButton=false;
            // }
            if(this.tenderDetail.reminder=='1'){
              this.savereminder = '1';
            }
            if(tenderDetails.status=='WTQUOTE' || (tenderDetails.status=='NORESPONSE' && this.issupplier=='false')){
              this.showInput=false;
            }else{
              this.showInput=true;
            }
          } else throw cusError(this.$t("warning_pageText.HAVENOSUCHTENDER"));
        })
        .catch(error => {
          throw error;
        });
    },
    //供应商列表点击进入
    getTenderDetail_2() {
      return postRequest("getList", {
        reqname: "getudztb",
        hrid: this.hrid,
        udztbnum: this.id,
        page: "1",
        pagesize: this.totalcount,
        str: "",
        status: "in ('"+ this.status +"')"
      })
        .then(res => {
          const data = res.data;
          if (data.getudztb.length) {
            const tenderDetails = data.getudztb[0];
            this.tenderDetail.title.value = tenderDetails.rfqnum;
            this.tenderDetail.udztbid = tenderDetails.udztbid;
            this.tenderDetail.suppliername.value = tenderDetails.suppliername;
            this.tenderDetail.content.value = tenderDetails.tenderdesc;
            this.tenderDetail.unit = tenderDetails.unit;
            this.tenderDetail.remark.value = tenderDetails.remark;
            this.tenderDetail.supplier.value = tenderDetails.commentstojll;
            this.tenderDetail.notes = tenderDetails.linenotes;
            this.tenderDetail.status = tenderDetails.status;
            this.tenderDetail.closingdate.value = tenderDetails.enddate;
            this.tenderDetail.reminder = tenderDetails.reminder;
            this.tenderDetail.tendercollectvia = tenderDetails.tendercollectvia;
            this.tenderDetail.tendercollectvias.value = tenderDetails.tendercollectvia;
            this.tenderEnddate = new Date(tenderDetails.enddate);
            // console.log(new Date(tenderDetails.enddate));
            // console.log(this.tenderEnddate);
            this.tenderDetail.contact1.value = (tenderDetails.contact1 )
            +(tenderDetails.email1!="" ? " ," + tenderDetails.email1 : tenderDetails.email1)
            +(tenderDetails.phone1!="" ? " ," + tenderDetails.phone1 : tenderDetails.phone1);
            this.tenderDetail.contact2.value = (tenderDetails.contact2 )
            +(tenderDetails.email2!="" ? " ," + tenderDetails.email2 : tenderDetails.email2)
            +(tenderDetails.phone2!="" ? " ," + tenderDetails.phone2 : tenderDetails.phone2);
            // if(tenderDetails.tendercollectvia=="HardCopy"){
            //   this.showButton=false;
            // }
           if(tenderDetails.status=='WTQUOTE' || (tenderDetails.status=='NORESPONSE' && this.issupplier=='false')){
              this.showInput=false;
            }else{
              this.showInput=true;
            }
            if(this.tenderDetail.reminder=='1'){
              this.savereminder = '1';
            }
            // console.log("this.tenderDetail");
            // console.log(this.tenderDetail);
            // console.log('tenderIsOverdue');
            // console.log(this.tenderIsOverdue);
            // console.log(tenderDetails);
          } else throw cusError(this.$t("warning_pageText.HAVENOSUCHTENDER"));
        })
        .catch(error => {
          throw error;
        });
    },
    //代报价
    getTenderDetail_3() {
      return postRequest("getList", {
        reqname: "getudztb",
        hrid: this.suppliername,
        udztbnum: this.id,
        page: "1",
        pagesize: "1",
        str: this.rfqnum,
        status: "in ('"+ this.status +"')"
      })
        .then(res => {
          const data = res.data;
          if (data.getudztb.length) {
            const tenderDetails = data.getudztb[0];
            this.tenderDetail.title.value = tenderDetails.rfqnum;
            this.tenderDetail.udztbid = tenderDetails.udztbid;
            this.tenderDetail.suppliername.value = tenderDetails.suppliername;
            this.tenderDetail.content.value = tenderDetails.tenderdesc;
            this.tenderDetail.unit=tenderDetails.unit;
            this.tenderDetail.remark.value=tenderDetails.remark;
            this.tenderDetail.supplier.value=tenderDetails.commentstojll;
            this.tenderDetail.notes=tenderDetails.linenotes;
            this.tenderDetail.status=tenderDetails.status;
            this.tenderDetail.closingdate.value=tenderDetails.enddate.toString();
            this.tenderDetail.bidmethod=tenderDetails.BIDMETHOD;
            this.tenderDetail.inputed=tenderDetails.inputed;
            this.tenderDetail.tendercollectvias.value = tenderDetails.tendercollectvia;
            this.tenderDetail.contact1.value=(tenderDetails.contact1 )
            +(tenderDetails.email1!="" ? " ," + tenderDetails.email1 : tenderDetails.email1)
            +(tenderDetails.phone1!="" ? " ," + tenderDetails.phone1 : tenderDetails.phone1);
            this.tenderDetail.contact2.value=(tenderDetails.contact2 )
            +(tenderDetails.email2!="" ? " ," + tenderDetails.email2 : tenderDetails.email2)
            +(tenderDetails.phone2!="" ? " ," + tenderDetails.phone2 : tenderDetails.phone2);
            // console.log('daibaojia');
            // console.log(tenderDetails);
            //  console.log(this.tenderDetail);
            if(tenderDetails.tendercollectvia=="HardCopy"){
              this.showButton=false;
            }
            if(tenderDetails.status=='WTQUOTE' || (tenderDetails.BIDMETHOD=='HardCopy' && tenderDetails.inputed=='0')){
              this.showInput=false;
            }else{
              this.showInput=true;
            }
          } else throw cusError(this.$t("warning_pageText.HAVENOSUCHTENDER"));
        })
        .catch(error => {
          throw error;
        }).finally(()=>{
          // console.log("tender3finish");
        });
    },
    getList() {
      return postRequest("getList", {
        reqname: "getudztbline",
        siteid: this.siteid,
        udztbnum: this.id
      })
        .then(res => {
          if (res.data.success) {
            this.list = res.data.getudztbline;
            this.paginationConfig.total = this.list.length;
            this.tableData = this.paging(
              this.paginationConfig.pageSize,
              this.paginationConfig.page
            );
            //console.log(this.tableData);
            for(let i=0;i<this.tableData.length;i++){
              let amount = this.formater(this.tableData[i].totallineamount);
              let unitprice = this.formater(this.tableData[i].unitprice);
              this.tableData[i].totallineamount = amount;
              this.tableData[i].unitprice = unitprice;
            }
            //console.log(this.tableData);
            //console.log(this.list.$index);
          } else throw cusError(this.$t("warning_pageText.HAVENOSUCHTENDER"));
        })
        .catch(error => {
          throw error;
        }).finally(()=>{
          //console.log("getlistfinish");
        });
    },
    getTenderInfo() {
      this.loading = true;
      if(this.str && this.issupplier=='true'){
        //console.log("1111111");
        this.getTenderDetail_1()
        .then(this.getList)
        .catch(error => {
          this.loading = false;
          if (error.name == "cusError") this.$message.error(error.message);
          else this.$message.error(this.$t("warning_pageText.CONNECTFAIL"));
        })
        .finally(() => {
          this.loading = false;
        });   
      }else if (!this.str && this.issupplier=='true'){
        //console.log("22222222");
        this.getTenderDetail_2()
        .then(this.getList)
        .catch(error => {
          this.loading = false;
          if (error.name == "cusError") this.$message.error(error.message);
          else this.$message.error(this.$t("warning_pageText.CONNECTFAIL"));
        })
        .finally(() => {
          this.loading = false;
        });   
      }else if(this.issupplier=='false'){
        //console.log("33333333");
        this.getTenderDetail_3()
        .then(this.getList)
        .catch(error => {
          this.loading = false;
          if (error.name == "cusError") this.$message.error(error.message);
          else this.$message.error(this.$t("warning_pageText.CONNECTFAIL"));
        })
        .finally(() => {
          this.loading = false;
        }); 
      }else{
         //console.log("44444444");
      }
        
    },
    getAttachments() {
      this.attachmentLoading = true;
      return postRequest("getList", {
        reqname: "getudztbdoc",
        udztbnum: this.id
      })
        .then(res => {
          if (res.data.success) {
            this.attachments = res.data.getudztbdoc;
            //console.log(this.attachments);
          } else throw cusError(res.data.message);
        })
        .catch(error => {
          this.attachmentLoading = false;
          if (error.name == "cusError") this.$message.error(error.message);
          else this.$message.error(this.$t("warning_pageText.CONNECTFAIL"));
        })
        .finally(() => {
          this.attachmentLoading = false;
        });
    },
    getSupplierAttachments() {
      this.supplierattachmentLoading = true;
      return postRequest("getList", {
        reqname: "getsupplierdoc",
        udztbnum: this.id
      })
        .then(res => {
          if (res.data.success) {
            this.supplierattachments = res.data.getsupplierdoc;
            // console.log('sssss');
            // console.log(this.supplierattachments);
          } else throw cusError(res.data.message);
        })
        .catch(error => {
          this.supplierattachmentLoading = false;
          if (error.name == "cusError") this.$message.error(error.message);
          else this.$message.error(this.$t("warning_pageText.CONNECTFAIL"));
        })
        .finally(() => {
          this.supplierattachmentLoading = false;
        });
    },
    getDialogHtml(){
      return postRequest("getList",{
        reqname: "getterms",
      })
      .then(res => {
        if(res.data.success){
          //console.log('12345');
          //console.log(res.data.getterms[0].message);
          this.dialogHtml = res.data.getterms[0].message;
         
        }
      })
      .catch(error => {
          
        })
      .finally(() => {

      });
    },
    confirmSubmit() {
      let _this = this;
      _this.checkSession();
      if(_this.tenderDetail.tendercollectvia=='HardCopy'){
         _this.$alert( _this.noDeclineTips , 'Tips',{
                    confirmButtonText: _this.$t("common_pageText.CONFIRM"),
                    //cancelButtonText: this.$t("common_pageText.CANCEL"),
                    type:'warning',
                    dangerouslyUseHTMLString: true
                }).then(()=>{
                    _this.uploadVisible=false; 
                    _this.savebutton = true;
                }).catch((e) => {
                    
                });
      }else{
        if (!_this.checkData()) return;
        _this.promptVisible = true;
      }
      
    },
    savePrice(){
      let _this = this;
      if(_this.checksession){
         _this.checkSession();
        if(_this.tenderDetail.tendercollectvia=='HardCopy'){
          _this.$alert( _this.noDeclineTips , 'Tips',{
                      confirmButtonText: _this.$t("common_pageText.CONFIRM"),
                      //cancelButtonText: this.$t("common_pageText.CANCEL"),
                      type:'warning',
                      dangerouslyUseHTMLString: true
                  }).then(()=>{
                      _this.uploadVisible=false; 
                      _this.savebutton = true;
                  }).catch((e) => {
                      
                  });
        }else{
          if(new Date()>new Date(_this.tenderEnddate)){
            _this.$message.error(_this.$t("warning_pageText.TENDERISOVERDUE"));
          }else{
            if(_this.tenderDetail.reminder=='0'){
              _this.saveTipsShow = true;
            }else{
              _this.update_savePrice();
            }
            //
          }
        }      
      }
     
    },
    savePriceInputed(){
      this.checkSession();
      if(this.checksession){
        this.update_supplier();
      }
    },
    saveUpload(){
      this.checkSession();
      if(this.checksession){
        this.savebutton = true;
        this.changeFileList();
        this.uploadSave();
      }   
    },
    saveSubmit(){
      this.checkSession();
      if(this.checksession){
        if(new Date()>new Date(this.tenderEnddate)){
        this.$message.error(this.$t("warning_pageText.TENDERISOVERDUE"));
        }else{
          this.agreeButtonDisabled = true;
          this.submit();
        }
      } 
    },
    submit() {
      // todo submit process
      this.loading = true;
      this.update()
        .then(this.workflow)
        .catch(error => {
          if (error.name == "cusError") this.$message.error(error.message);
          else this.$message.error(this.$t("warning_pageText.CONNECTFAIL"));
        })
        .finally(() => {
          this.loading = false;
          this.promptVisible = false;
          this.$router.go(0);
        });
    },
    workflow() {
      return postRequest("submitWorkflow", {
        assigncode: this.hrid,
        ownertable: "udztb",
        ownerid: this.tenderDetail.udztbid,
        actionid: "4"
      })
        .then(res => {
          if (!res.data.success) {
            throw cusError(res.data.message);
          }else{
            this.$store.commit("user/setUrlStatus2", this.$route.params.status);
            this.$router.push({
              params:merge(this.$route.params,{'status':res.data.status})
            });
          }
        })
        .catch(error => {
          throw error;
        });
    },
    workflowAccept() {
      let _this = this;
      return postRequest("submitWorkflow", {
        assigncode: this.hrid,
        ownertable: "udztb",
        ownerid: this.tenderDetail.udztbid,
        actionid: "7"
      })
        .then(res => {
          if (res.data.success) {
            this.$store.commit("user/setUrlStatus", this.$route.params.status);
            this.$router.push({
              params:merge(this.$route.params,{'status':res.data.status})
            });
            this.$router.go(0); 
                 
          }else{
            _this.$message.error(res.data.message);
          }
        })
        .catch(error => {
          throw error;
        });
    },
    workflowReject() {
      let _this = this;
      return postRequest("submitWorkflow", {
        assigncode: _this.hrid,
        ownertable: "udztb",
        ownerid: _this.tenderDetail.udztbid,
        commentstojll: _this.rejectreason,
        actionid: "8"
      })
        .then(res => {
          if (!res.data.success) {
            _this.$message.error(res.data.message);
          }else{
            _this.showButton_3 = true;
            _this.$store.commit("user/setUrlStatus", _this.$route.params.status);
            _this.$router.push({
              params:merge(this.$route.params,{'status':res.data.status})
            });
            const updateudztbline = _this.list.map(item => {
              const tem = {};
              tem.seqno = item.seqno;
              tem.udztbnum = _this.id;
              return tem;
            });
             return postRequest("update", {
                reqname: "updateudztb",
                user: _this.hrid,
                udztb: [
                  {
                    udztbnum: _this.id,
                    updateudztbline: updateudztbline,
                    commentstojll: _this.rejectreason,  
                  }
                ]
                })
                .then(res => {
                  if (!res.data.success)
                    throw cusError(_this.$t("warning_pageText.QUOTEFAILED"));
                  else {
                    //console.log('reject reason');
                    _this.$router.go(0);
                  }
                })
                .catch(error => {
                  throw error;
                });
          }
        })
        .catch(error => {
          throw error;
        });
    },
    acceptTender(){
      let _this = this;
      _this.checkSession();
      if(_this.checksession){
        _this.$confirm( 'Will you be able to start the quotation confirmation after clicking ?' , _this.$t("common_pageText.PROMPT"),{
                      confirmButtonText: _this.$t("common_pageText.CONFIRM"),
                      cancelButtonText: _this.$t("common_pageText.CANCEL"),
                      type:'warning',
                      showClose:false
                    }).then(()=>{
                     _this.workflowAccept();
                    }).catch((e) => {
                        //_this.showButton_2 = false;
                    });
      }
    },
    HCreject(){
      let _this = this;
      _this.uploadVisible = false; 
      _this.rejectVisible = false;
      _this.savebutton = true;
    },
    NHCreject(){
      let _this = this;
      if(new Date()>new Date(_this.tenderEnddate)){
        _this.$message.error(_this.$t("warning_pageText.TENDERISOVERDUE"));
      }else{
        if(_this.tenderDetail.status=='WTQUOTE')
        _this.workflowReject_afteraccept();
        else _this.workflowReject();
      }
    },
    rejectTender(){
      let _this = this;
      _this.checkSession();
      if(_this.checksession){
        _this.rejectVisible = true;
      }
      return;
      //_this.checkSession();
      if(_this.checksession){
        if(_this.tenderDetail.tendercollectvia=='HardCopy'){
        //_this.noDeclineTipsShow = true;
          _this.$alert(_this.noDeclineTips , 'Tips',{
                      confirmButtonText: _this.$t("common_pageText.CONFIRM"),
                      //cancelButtonText: this.$t("common_pageText.CANCEL"),
                      type:'warning',
                      dangerouslyUseHTMLString: true
                  }).then(()=>{
                      _this.uploadVisible=false; 
                      _this.savebutton = true;
                  }).catch((e) => {
                      
                  });
        }else{
          _this.$confirm( _this.$t("tenderInfo_pageText.REJECT_TIPS") , _this.$t("common_pageText.PROMPT"),{
                          confirmButtonText: _this.$t("common_pageText.CONFIRM"),
                          cancelButtonText: _this.$t("common_pageText.CANCEL"),
                          type:'warning',
                          showClose:false
                      }).then(()=>{
                        if(new Date()>new Date(_this.tenderEnddate)){
                          _this.$message.error(_this.$t("warning_pageText.TENDERISOVERDUE"));
                        }else{
                          if(_this.tenderDetail.status=='WTQUOTE')
                          _this.workflowReject_afteraccept();
                          else _this.workflowReject();
                        }
                      }).catch((e) => {
                          //_this.showButton_2 = false;
                      });
        }
      } 
    },
     workflowReject_afteraccept() {
      let _this = this;
      return postRequest("submitWorkflow", {
        assigncode: _this.hrid,
        ownertable: "udztb",
        ownerid: _this.tenderDetail.udztbid,
        commentstojll: this.rejectreason,
        actionid: "9"
      })
        .then(res => {
          if (!res.data.success) {
            _this.$message.error(res.data.message);
          }else{
            _this.showButton_3 = true;
            _this.$store.commit("user/setUrlStatus", _this.$route.params.status);
            _this.$router.push({
              params:merge(_this.$route.params,{'status':res.data.status})
            });
            const updateudztbline = _this.list.map(item => {
              const tem = {};
              tem.seqno = item.seqno;
              tem.udztbnum = _this.id;
              return tem;
            });
             return postRequest("update", {
                reqname: "updateudztb",
                user: _this.hrid,
                udztb: [
                  {
                    udztbnum: _this.id,
                    updateudztbline: updateudztbline,
                    commentstojll: _this.rejectreason,  
                  }
                ]
                })
                .then(res => {
                  if (!res.data.success)
                    throw cusError(_this.$t("warning_pageText.QUOTEFAILED"));
                  else {
                    //console.log('reject reason');
                    _this.$router.go(0);
                  }
                })
                .catch(error => {
                  throw error;
                });
          }
        })
        .catch(error => {
          throw error;
        });
    },
    update() {
      const updateudztbline = this.list.map(item => {
        const tem = {};
          tem.seqno = item.seqno;
          tem.udztbnum = this.id;

          if(item.quantity){
          tem.quantity = item.quantity.toString();
          }
          if(item.unitprice){
            tem.unitprice = this.unformat(item.unitprice).toString();
          }
          if(item.totallineamount){
            tem.totallineamount = this.unformat(item.totallineamount).toString();
          }
          if(item.linenotes && item.linenotes!=""){
            tem.linenotes = item.linenotes;
          }
        
        //console.log(tem.unitprice);
        return tem;
      });
      return postRequest("update", {
        reqname: "updateudztb",
        user: this.hrid,
        udztb: [
          {
            udztbnum: this.id,
            docinfo: this.fileList,
            updateudztbline: updateudztbline,
            commentstojll:this.tenderDetail.supplier.value,
          }
        ]
      })
        .then(res => {
          if (!res.data.success)
            throw cusError(this.$t("warning_pageText.QUOTEFAILED"));
        })
        .catch(error => {
          throw error;
        });
    },
     update_savePrice() {
      let seqNoList = "";
      const updateudztbline = this.list.map(item => {
        const tem = {};
        tem.seqno = item.seqno;
        tem.udztbnum = this.id;
        if(item.quantity){
          tem.quantity = item.quantity.toString();
        }
        if(item.unitprice || item.totallineamount){
          if(!isNaN(this.unformat(item.unitprice)) )
            tem.unitprice = this.unformat(item.unitprice).toString();
          if(!isNaN(this.unformat(item.totallineamount)))
            tem.totallineamount = this.unformat(item.totallineamount).toString();
          /*else seqNoList += ` ${item.seqno}`;*/
          if ((item.unitprice && isNaN(this.unformat(item.unitprice)))
                || (item.totallineamount && isNaN(this.unformat(item.totallineamount)))){
              seqNoList += ` ${item.seqno}`;
          }
        }
        /*if(item.totallineamount){
          if(!isNaN(this.unformat(item.totallineamount)))
          tem.totallineamount = this.unformat(item.totallineamount).toString();
          else seqNoList += ` ${item.seqno}`;
        }*/
        if(item.linenotes && item.linenotes!=""){
          tem.linenotes = item.linenotes;
        }
        console.log(tem);
        return tem;
      });
      if (seqNoList) {
        /*this.$message.error(
          `${this.$t("warning_pageText.CONFIRMREQUIRE")}${seqNoList}`
        );*/
        this.$alert( `${this.$t("warning_pageText.CONFIRMREQUIRE")}`+'<b>'+`${seqNoList}`+'</b>' , 'Tips',{
          confirmButtonText: this.$t("common_pageText.CONFIRM"),
          type:'danger',
          dangerouslyUseHTMLString: true
        }).then(()=>{

        }).catch((e) => {

        });
        //this.saveSuccess = false;
        this.saveButtonDisabled = false;
        return false;
      }
      return postRequest("update", {
      reqname: "updateudztb",
      user: this.hrid,
      udztb: [
        {
          udztbnum: this.id,
          docinfo: this.fileList,
          updateudztbline: updateudztbline,
          commentstojll: this.tenderDetail.supplier.value,
          reminder: this.savereminder
        }
      ]
      })
      .then(res => {
        if (!res.data.success)
          throw cusError(this.$t("warning_pageText.QUOTEFAILED"));
        else this.$router.go(0);
      })
      .catch(error => {
        throw error;
      });
     
      
    },
    update_supplier(){
      //this.checkSession();
      let seqNoList = "";
      const updateudztbline = this.list.map(item => {
        const tem = {};
        tem.seqno = item.seqno;
        tem.udztbnum = this.id;
        if(item.quantity){
          tem.quantity = item.quantity.toString();
        }
        if(item.unitprice){
          if(!isNaN(this.unformat(item.unitprice)))
          tem.unitprice = this.unformat(item.unitprice).toString();
          else seqNoList += ` ${item.seqno}`;
        }
        if(item.totallineamount){
          if(!isNaN(this.unformat(item.totallineamount)))
          tem.totallineamount = this.unformat(item.totallineamount).toString();
          else seqNoList += ` ${item.seqno}`;
        }
        if(item.linenotes && item.linenotes!=""){
          tem.linenotes = item.linenotes;
        }
        //console.log(tem);
        return tem;
      });
      if (seqNoList) {
        this.$message.error(
          `${this.$t("warning_pageText.CONFIRMREQUIRE")}${seqNoList}`
        );
        //this.saveSuccess = false;
        return false;
      }
      return postRequest("update", {
      reqname: "updateudztb_supp",
      user: this.hrid,
      udztb: [
        {
          udztbnum: this.id,
          docinfo: this.fileList,
          updateudztbline: updateudztbline,
          commentstojll:this.tenderDetail.supplier.value,
        }
      ]
      })
      .then(res => {
        if (!res.data.success)
          throw cusError(this.$t("warning_pageText.QUOTEFAILED"));
        else this.$router.go(0);
      })
      .catch(error => {
        throw error;
      });
    },
    checkData() {
      // const seq = this.list.filter(item => (isNaN(item.unitprice)||item.unitprice == ""));
      let seqNoList = "";
      let zeroNoList = "";
      //判断如果没有报价行且没有上传附件则提示必须上传附件
      if (!this.list.length && !this.supplierattachments.length){
        this.$alert(`${this.$t("warning_pageText.MUSTUPLOADFILE")}`);
        return ;
      }
      this.list.forEach(item => {
        if(item.header!=1){
          /*if(item.required==1){
            if(!item.unitprice || isNaN(this.unformat(item.unitprice))){
              seqNoList += ` ${item.seqno}`;
            }
            if(item.unitprice && item.unitprice==0){
              zeroNoList += ` ${item.seqno}`;
            }
          }
          if(item.qtyrequired==1){
            if(!item.quantity){
              seqNoList += ` ${item.seqno}`;
            }
          }
          if(item.totalamountreq==1){
            if(!item.totallineamount || isNaN(this.unformat(item.totallineamount))){
              seqNoList += ` ${item.seqno}`;
            }   
            if(item.totallineamount && item.totallineamount==0){
              zeroNoList += ` ${item.seqno}`;
            }
          }*/
          if(item.required==1 || item.totalamountreq==1){
            if((item.unitprice && isNaN(this.unformat(item.unitprice)))
                    || (item.totallineamount && isNaN(this.unformat(item.totallineamount)))
                    || (item.required==1 && !item.unitprice)
                    || (item.totalamountreq==1 && !item.totallineamount)){
              if(seqNoList == ""){
                seqNoList += ` ${item.seqno}`;
              }else{
                seqNoList += ',' + ` ${item.seqno}`;
              }
            }
          }
          if((item.totallineamount && item.totallineamount==0) || (item.unitprice && item.unitprice==0)){
              zeroNoList += ` ${item.seqno}`;
          }
        }
      });
      if (seqNoList || zeroNoList) {
        if(seqNoList && zeroNoList){
          this.$alert( `${this.$t("warning_pageText.CONFIRMREQUIRE")}`+'<b>'+`${seqNoList}`+'</b>' + '<br>' 
          + `${this.$t("warning_pageText.CONFIRMZERO")}`+'<b>'+`${zeroNoList}`+'</b>', 'Tips',{
                      confirmButtonText: this.$t("common_pageText.CONFIRM"),
                      type:'danger',
                      dangerouslyUseHTMLString: true
                  }).then(()=>{

                  }).catch((e) => {
                      
                  });
          // this.$message.error(
          // `${this.$t("warning_pageText.CONFIRMREQUIRE")}${seqNoList}`+`${this.$t("warning_pageText.CONFIRMZERO")}${zeroNoList}`);
        }
        if (zeroNoList && !seqNoList){
          this.$alert(`${this.$t("warning_pageText.CONFIRMZERO")}`+'<b>'+`${zeroNoList}`+'</b>', 'Tips',{
                        confirmButtonText: this.$t("common_pageText.CONFIRM"),
                        type:'danger',
                        dangerouslyUseHTMLString: true
                    }).then(()=>{
                      
                    }).catch((e) => {
                        
                    });
        }
        if (seqNoList && !zeroNoList){
          this.$alert( `${this.$t("warning_pageText.CONFIRMREQUIRE")}`+'<b>'+`${seqNoList}`+'</b>', 'Tips',{
                        confirmButtonText: this.$t("common_pageText.CONFIRM"),
                        type:'danger',
                        dangerouslyUseHTMLString: true
                    }).then(()=>{
                      
                    }).catch((e) => {
                        
                    });
        }
        return false;
      } else return true;
    },
    tableHeaderCellClassName({ row, column, rowIndex, columnIndex }) {
      return "ui-table-header-cell";
    },
    tableContentCellClassName({ row, column, rowIndex, columnIndex }) {
      if (columnIndex !== 0 && columnIndex !== 2) {
        return "ui-table-content-cell";
      }
    },
    handleCurrentChange(page) {
      this.checkSession();
      if(this.checksession){
        this.paginationConfig.page = page;
        this.tableData = this.paging(this.paginationConfig.pageSize, page);
      }
    },
    paging(pageSize, page) {
      const tablePush = [];
      this.list.forEach((item, index) => {
        if (pageSize * (page - 1) <= index && index <= pageSize * page - 1) {
          tablePush.push(item);
        }
      });
      return tablePush;
    },
    getBase64(file) {
      //把转成base64编码
      return new Promise(function(resolve, reject) {
        let reader = new FileReader();
        let fileResult = "";
        reader.readAsDataURL(file);
        reader.onload = function() {
          fileResult = reader.result;
        };
        reader.onerror = function(error) {
          reject(error);
        };
        reader.onloadend = function() {
          resolve(fileResult);
        };
      });
    },
    upload(file, fileList) {
      this.checkSession();
      if(this.checksession){
        this.uploadLoading = true;
        this.getBase64(file.raw)
          .then(res => {
            let size = this.fileList.length;
            this.fileList.push({
              name: file.name,
              filename: file.name,
              filebyte: res,
              description: this.filedesc
            });
            if (size < this.fileList.length) {
              this.$message.success(
                `[${this.$t("warning_pageText.SUCCESS")}]  ${file.name}`
              );
            }
          })
          .catch(error => {
            this.uploadLoading = false;
            this.$message.error(
              `[${this.$t("warning_pageText.FAILURE")}]  ${file.name}`
            );
          })
          .finally(() => {
            //this.changeFileList();
            this.uploadLoading = false;
          });
      }   
    },
    uploadSave(){
      const updateudztbline = this.list.map(item => {
       const tem = {};
        tem.seqno = item.seqno;
        tem.udztbnum = this.id;
        // if(item.quantity){
        //   //tem.quantity = item.quantity.toString();
        // }
        // if(item.unitprice){
         
        //   //tem.unitprice = this.unformat(item.unitprice).toString();
        // }
        // if(item.totallineamount){
         
        //   //tem.totallineamount = this.unformat(item.totallineamount).toString();
        // }
        // if(item.linenotes && item.linenotes!=""){
        //   //tem.linenotes = item.linenotes;
        // }
        // console.log(tem);
        return tem;
      });
      return postRequest("update", {
        reqname: "updateudztb",
        user: this.hrid,
        udztb: [
          {
            udztbnum: this.id,
            docinfo: this.fileList,
            updateudztbline: updateudztbline,
            isAttachment: true
          }
        ]
      })
        .then(res => {
          if (!res.data.success){
            this.$message.error(this.$t("warning_pageText.CANNOTUPLOAD"));
            this.savebutton = false;
          }else{
            this.$router.go(0);
          }
            
        })
        .catch(error => {
          throw error;
        })
        .finally(()=>{
          //this.savebutton = false;
           //console.log(this.$refs.upload);
        });
    },
    handleRemove(file) {
      // 实现缩略图模板时删除文件
      this.checkSession();
      if(this.checksession){
        let fileList1 = this.$refs.upload.uploadFiles;
        let index = fileList1.findIndex( fileItem => {
          return fileItem.uid === file.uid
        })
        
        fileList1.splice(index, 0);
        
        this.fileList = fileList1;
      }
      
      //console.log(this.fileList);
    },
    download(url) {
      this.checkSession();
      if(this.checksession){
        window.location.href = url;
      }  
    },
    deleteUploadFile(docid){
      this.checkSession();
      if(this.checksession){
        return postRequest("update",{
          reqname: "deleteudztbfile",
          user: this.hrid,
          udztb: [
            {
              udztbnum: this.id,
              docinfoid: docid
            }
          ]
        }).then(res=>{
          if(!res.data.success){
            //console.log('delete failed');
          }else{
            //this.$router.go(0);
            this.getSupplierAttachments();
          }
        }).catch(error => {
            throw error;
        }).finally(()=>{
            this.supplierattachmentVisible = true;
            //this.savebutton = false;
            //console.log(this.$refs.upload);
        });
      }
      //console.log(docid);
      
    },
    saveTipsConfirm(){
      this.checkSession();
      if(this.checksession){
        if(this.checked){
          this.savereminder = "1";
        }
        this.saveButtonDisabled = true;
        this.saveTipsShow = false;
        this.update_savePrice();
      }
      
    },
    runRpt() {
      this.checkSession();
      if(this.checksession){
        this.running = true;
        let url = getRptIP("UDZTB/supplier_biddding_cost", { udztbnum : this.id });
        window.open(url, "_blank"); 
        this.running = false;
      }
    },
    rowStyle({ row, column, rowIndex, columnIndex }) {
	           if (rowIndex>=0) {   
               if(row.header==1){
                 return 'background:#C0C0C0;'
               }	            
	  		  	}
    },
    changeUploadVisible(){
      this.checkSession();
      if(this.checksession){
        let _this = this;
        if(_this.tenderDetail.status=='WTQUOTE'){
          if(_this.tenderDetail.tendercollectvia=='HardCopy'){
            //_this.noDeclineTipsShow = true;
            _this.$alert( this.noDeclineTips , 'Tips',{
                      confirmButtonText: this.$t("common_pageText.CONFIRM"),
                      //cancelButtonText: this.$t("common_pageText.CANCEL"),
                      type:'warning',
                      dangerouslyUseHTMLString: true
                  }).then(()=>{
                      this.uploadVisible=false; 
                      this.savebutton = true;
                  }).catch((e) => {
                      
                  });
          }else{
            _this.$confirm( this.uploadTips , 'Tips',{
                          confirmButtonText: this.$t("common_pageText.CONFIRM"),
                          cancelButtonText: this.$t("common_pageText.CANCEL"),
                          type:'warning',
                          dangerouslyUseHTMLString: true
                      }).then(()=>{
                        this.uploadVisible=true; 
                        this.savebutton = false;
                      }).catch((e) => {
                          
                      });
          } 
        }else{
          this.uploadVisible=true; 
          this.savebutton = false;
        }
      }
    },
    getUploadTips(){
      return postRequest("getList", {
        reqname: "getmessageutil",
        templateid: "UPLOADTIPS"
      })
        .then(res => {
          if (!res.data.success)
            throw cusError(this.$t("warning_pageText.QUOTEFAILED"));
          else {
            // console.log("UPLOADTIPS");
            // console.log(res.data.getmessageutil[0].message);
            this.uploadTips = res.data.getmessageutil[0].message;
          }
        })
        .catch(error => {
          throw error;
        });
    },
    getSaveTips(){
      return postRequest("getList", {
        reqname: "getmessageutil",
        templateid: "savetips"
      })
        .then(res => {
          if (!res.data.success)
            throw cusError(this.$t("warning_pageText.QUOTEFAILED"));
          else {
            // console.log("savetips");
            // console.log(res.data.getmessageutil[0].message);
            this.saveTips = res.data.getmessageutil[0].message;
          }
        })
        .catch(error => {
          throw error;
        });
    },
    getNoDeclineTips(){
      return postRequest("getList", {
        reqname: "getmessageutil",
        templateid: "nodecline"
      })
        .then(res => {
          if (!res.data.success)
            throw cusError(this.$t("warning_pageText.QUOTEFAILED"));
          else {
            // console.log("nodecline");
            // console.log(res.data.getmessageutil[0].message);
            this.noDeclineTips = res.data.getmessageutil[0].message;
          }
        })
        .catch(error => {
          throw error;
        });
    },
    getNoReminderTips(){
      return postRequest("getList", {
        reqname: "getmessageutil",
        templateid: "noreminder"
      })
        .then(res => {
          if (!res.data.success)
            throw cusError(this.$t("warning_pageText.QUOTEFAILED"));
          else {
            // console.log("noreminder");
            // console.log(res.data.getmessageutil[0].message);
            this.noReminderTips = res.data.getmessageutil[0].message;
          }
        })
        .catch(error => {
          throw error;
        });
    },
    checkSession(){
      let _this = this;
      return new Promise((resolve, reject) => {
        postRequest("checkSession", {
          hrid: _this.hrid,
          clienthost: sessionStorage.getItem('ip') ? sessionStorage.getItem('ip') : '127.0.0.1',
          maxsessionid: (!sessionStorage.getItem('maxsessionid') || sessionStorage.getItem('maxsessionid')=='')? '0' : sessionStorage.getItem('maxsessionid'),
          result: sessionStorage.getItem('sessionresult') ? sessionStorage.getItem('sessionresult') : '2',
        })
          .then(res => {
            let datas = res.data;
            //console.log(datas);
            //return;
            if(!datas.success){
              _this.checksession = false;
              sessionStorage.setItem('sessionresult','0');
              _this.$message.error({
                 message: (!sessionStorage.getItem("timeOutTips") || sessionStorage.getItem("timeOutTips")=='') ? 
                'Your session has timed out. Please log in again.' : sessionStorage.getItem("timeOutTips"),
                duration: 4000
              });
              setTimeout(function (){
                _this.logout();
              }, 3000);
            }else{
             sessionStorage.setItem('sessionresult','1');
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    logout() {
      let _this = this;
      _this.user.loginid = _this.hrid;
      _this.user.token = token;
      _this
        .logoutHandle(_this.user)
        .then(res => {
          if (res.success) {
            _this.$router.go(0);
            _this.$store.commit("user/removeUser");
            _this.$router.replace("/login?langcode=" + _this.$i18n.locale);
            
          } else {
            _this.$message.error(res.message);
          }
        })
        .catch(error => {
          _this.$message.error(_this.$t("warning_pageText.CONNECTFAIL"));
        });
    },
    logoutHandle(user) {
      return new Promise((resolve, reject) => {
        postRequest("userLogout", {
          loginid: user.loginid,
          logintype: user.logintype,
          token: user.token,
          maxsessionid: (!sessionStorage.getItem('maxsessionid') || sessionStorage.getItem('maxsessionid')=='')? '0' : sessionStorage.getItem('maxsessionid'),
        })
          .then(res => {
            resolve(res.data);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
     getTimeOutMessage(){
      return postRequest("getList", {
        reqname: "getmessageutil",
        templateid: "timeout"
      })
        .then(res => {
          if (!res.data.success)
            throw cusError(this.$t("warning_pageText.QUOTEFAILED"));
          else {
            this.timeOutTips = res.data.getmessageutil[0].message;
            console.log(this.timeOutTips);
          }
        })
        .catch(error => {
          throw error;
        });
    }
  },
  watch: {
    "$i18n.locale"(curVal, oldVal) {
      this.tenderDetail.title.label = this.$t("tenderInfo_pageText.TENDERNO");
      this.tenderDetail.content.label = this.$t(
        "tenderInfo_pageText.DESCRIPTION"
      );
      this.tableLabel.seqNo = this.$t("tenderInfo_pageText.SEQNO");
      this.tableLabel.description = this.$t("tenderInfo_pageText.DESCRIPTION");
      this.tableLabel.remark = this.$t("tenderInfo_pageText.REMARK");
      this.tableLabel.quantity = this.$t("tenderInfo_pageText.QUANTITY");
      this.tableLabel.unitPrice = this.$t("tenderInfo_pageText.UNITPRICE");
      this.tableLabel.lineTotal = this.$t("tenderInfo_pageText.LINETOTAL");
      this.tableLabel.attachments = this.$t("tenderInfo_pageText.ATTACHMENTS");
      this.tableLabel.attachmentId = this.$t(
        "tenderInfo_pageText.ATTACHMENTID"
      );
      this.tableLabel.attachmentType = this.$t(
        "tenderInfo_pageText.ATTACHMENTTYPE"
      );
      this.tableLabel.attachmentName = this.$t(
        "tenderInfo_pageText.ATTACHMENTNAME"
      );
      this.buttonLabel.more = this.$t("common_pageText.MORE");
      this.buttonLabel.return = this.$t("common_pageText.RETURN");
      this.buttonLabel.submit = this.$t("common_pageText.SUBMIT");
      this.buttonLabel.confirm = this.$t("common_pageText.CONFIRM");
      this.buttonLabel.cancel = this.$t("common_pageText.CANCEL");
      this.buttonLabel.download = this.$t("common_pageText.DOWNLOAD");
      this.buttonLabel.upload = this.$t("common_pageText.UPLOAD");
      this.buttonLabel.uploadattachment = this.$t(
        "tenderInfo_pageText.UPLOADATTACHMENT"
      );
      this.buttonLabel.addattachment = this.$t(
        "tenderInfo_pageText.ADDATTACHMENT"
      );
      this.buttonLabel.adding = this.$t("tenderInfo_pageText.ADDING");
      this.buttonLabel.viewattachments = this.$t(
        "tenderInfo_pageText.VIEWATTACHMENTS"
      );
      this.buttonLabel.print = this.$t("tenderInfo_pageText.PRINT");
      this.buttonLabel.loading = this.$t("tenderInfo_pageText.LOADING");
      this.promptText.prompt = this.$t("common_pageText.PROMPT");
      this.promptText.confirmSubmit = this.$t("prompt_pageText.CONFIRMSUBMIT");
      this.seqDetail.title.label = this.$t("tenderInfo_pageText.SEQNO");
    },
  }
};
</script>
<style>
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}

.dialoghtml{
 word-wrap:break-word;
}
input[type="number"]{
  -moz-appearance: textfield;
}
</style>
<style scoped>
.btn-attachment {
  width: 130px;
  height: 31px;
  line-height: 15px;
}
.attachment-group {
  justify-content: flex-end;
  align-items: flex-start;
}
.line-word-break{
  word-break: keep-all;
  overflow: hidden;
  -webkit-box-orient:horizontal;
}
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none !important;
}
input[type="number"]{
  -moz-appearance: textfield;
}
</style>

